import React from 'react';
import moment, { Moment } from 'moment-timezone';
import { chegouDataSorteio } from '../../utils/FunctionUtils';

interface Props {
	dataEncerramento?: string,
	onChegouDataSorteio?: (chegouSorteio: boolean) => void,
	tituloContainer?: string,
	hideContador?: boolean
}

interface State {
	dias: string,
	horas: string,
	minutos: string,
	segundos: string,
	dataEncerramento?: Moment
}

class ContadorRifa extends React.Component<Props, State> {
	_isMounted:boolean = false;

	constructor(props: Props) {
		super(props);

		this.state = {
			dias: "00",
			horas: "00",
			minutos: "00",
			segundos: "00",
			dataEncerramento: this.props.dataEncerramento ? moment.parseZone(this.props.dataEncerramento, undefined, 'America/Sao_Paulo') : undefined
		}
	}

	componentDidMount() {
		this._isMounted = true;
		if (this.props.dataEncerramento)
			window.setInterval(this.timer, 1000);
	}

	componentDidUpdate(prevProps: Props) {
		// Reseta o contador
		if (this.props.dataEncerramento && (this.props.dataEncerramento !== prevProps.dataEncerramento)) {
			window.clearInterval();
			window.setInterval(this.timer, 1000);

			if (this._isMounted) {
				this.setState({ 
					...this.state,
					dataEncerramento: this.props.dataEncerramento ? moment.parseZone(this.props.dataEncerramento, undefined, 'America/Sao_Paulo'): undefined
				})
			}
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.props.dataEncerramento)
			window.clearInterval();
	}

	timer = () => {
		if (!this.state.dataEncerramento)
			return;
		
		if (chegouDataSorteio(this.props.dataEncerramento)) {
			if (typeof this.props.onChegouDataSorteio === 'function')
				this.props.onChegouDataSorteio(true);
				
			return;
		}

		if (typeof this.props.onChegouDataSorteio === 'function')
			this.props.onChegouDataSorteio(false);

		// Adiciona horário de 6h da manhã à data de sorteio
		// Data do sorteio é do tipo yyyy-MM-dd
		let initialTimer = this.state.dataEncerramento;
		let horaBrasil = moment().tz('America/Sao_Paulo').parseZone();

		let tempoRestante = Math.abs(initialTimer.valueOf() - horaBrasil.valueOf() - horaBrasil.utcOffset()*60*1000);

		let tempoDias = tempoRestante / 1000 / 60 / 60 / 24;
		let tempoRestanteDias = Math.floor(tempoDias);
		let tempoHoras = (tempoDias - tempoRestanteDias) * 24;
		let tempoRestanteHoras = Math.floor(tempoHoras);
		let tempoMinutos = (tempoHoras - tempoRestanteHoras) * 60;
		let tempoRestanteMinutos = Math.floor(tempoMinutos);
		let tempoSegundos = (tempoMinutos - tempoRestanteMinutos) * 60
		let tempoRestanteSegundos = Math.floor(tempoSegundos);

		let dias: string = tempoRestanteDias.toString();
		let horas: string = (tempoRestanteHoras >= 10) ? tempoRestanteHoras.toString() : "0" + tempoRestanteHoras;
		let minutos: string = (tempoRestanteMinutos >= 10) ? 
			tempoRestanteMinutos.toString() : "0" + tempoRestanteMinutos;
		let segundos: string = (tempoRestanteSegundos >= 10) ? 
			tempoRestanteSegundos.toString() : "0" + tempoRestanteSegundos;

		
		if (this._isMounted) {
			this.setState({ 
				dias: dias, 
				horas: horas, 
				minutos: minutos, 
				segundos: segundos 
			});
		}
	};

	render() {
		const { dias, horas, minutos, segundos } = this.state;
		const {
			tituloContainer,
			hideContador
		} = this.props;

		return (
			<section id="contador-encerramento" className="text-center py-4">
				<div className="padding-x">
					<div>
						<span className={"title-sm-common" + ((process.env.REACT_APP_NOME_SISTEMA === "Rifa Tech") ? " title-primary" : "")}>
							{ tituloContainer ? tituloContainer : "Tempo até o sorteio" }
						</span>
					</div>

					{ hideContador 
						? null
						: <div className="px-5 pt-3 pb-0 pb-md-3" style={{maxWidth: "500px", margin: "0 auto" }}>
							<div className="row">
								<div className="col-xs-12 col-sm-6 col-md-3">
									<span className="number-wrap">
										<span id="idTimerDias" className="number-counter">{dias}</span>
										<span className="text-counter">Dias</span>
									</span>
								</div>
								<div className="col-xs-12 col-sm-6 col-md-3">
									<span className="number-wrap">
										<span id="idTimerHoras" className="number-counter">{horas}</span>
										<span className="text-counter">Horas</span>
									</span>
								</div>
								<div className="col-xs-12 col-sm-6 col-md-3">
									<span className="number-wrap">
										<span id="idTimerMinutos" className="number-counter">{minutos}</span>
										<span className="text-counter">Minutos</span>
									</span>
								</div>
								<div className="col-xs-12 col-sm-6 col-md-3">
									<span className="number-wrap">
										<span id="idTimerSegundos" className="number-counter">{segundos}</span>
										<span className="text-counter">Segundos</span>
									</span>
								</div>
							</div>
						</div>
					}
				</div>
			</section>
		);
	}
}

export default ContadorRifa;